const Tutorials = () => {
    return <h1>Tutorials Articles</h1>;
};
  
export default Tutorials;